import { render, staticRenderFns } from "./Deficiencias.vue?vue&type=template&id=1504af1d&"
import script from "./Deficiencias.vue?vue&type=script&lang=js&"
export * from "./Deficiencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports